// extracted by mini-css-extract-plugin
module.exports = {"time":"dateTime__time___2Hagq","date":"dateTime__date___1JWB3","wrapper":"dateTime__wrapper___2sx6x"};